export default {"src":"/_next/static/media/threads-icon.cf5f4d98.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};